<template>
  <ElementLayout>
    <!-- @vue-ignore -->
    <template #element>
      <!-- @vue-ignore -->
      <template v-if="items.length > 0">
        <!-- @vue-ignore -->
        <v-row v-for="(row, index) in dataList" :key="index" dense>
          <!-- @vue-ignore -->
          <v-col v-for="(item, idx) in items" :key="idx">
            <v-text-field
              v-model="row[item]"
              :placeholder="item"
              density="compact"
              class="vueform-combobox"
              hide-details
            ></v-text-field>
          </v-col>
        </v-row>
        <!-- @vue-ignore -->
        <v-btn
          variant="outlined"
          size="small"
          append-icon="mdi-plus"
          class="mt-2"
          style="border: solid thin #00000025;"
          @click="addRow"
        ><!-- @vue-ignore -->{{ $t('common.buttons.add') }}</v-btn>
      </template>
      <!-- @vue-ignore -->
      <v-text-field
        v-else
        :placeholder="$t('common.buttons.addCriterion')"
        density="compact"
        class="vueform-combobox"
      ></v-text-field>
    </template>
  </ElementLayout>
</template>

<script lang="ts">
import { defineElement } from '@vueform/vueform'
import { computed } from 'vue'

interface Element {
  value: string,
  update: Function
}
interface Attrs {
  items: string[]
}
interface Context {
  element: Element
  attrs: Attrs
}

export default defineElement({
  name: 'CustomMultilineElement',
  nullValue: [],
  setup(props: Object, { element, attrs }: Context) {
    const { value, update } = element
    
    // Make items reactive by using computed
    const items = computed(() => attrs.items || [])
    
    return { value, items, update }
  },
  data() {
    return {
      dataList: this.value.length === 0 ? [this.buildEmptyItem()] : this.value
    }
  },
  methods: {
    buildEmptyItem() {
      const itemObj: { [key: string]: string } = {}

      // @ts-ignore
      this.items.forEach((item: string) => {
        itemObj[item] = ''
      })

      return itemObj
    },
    addRow() {
      // @ts-ignore
      this.dataList.push(this.buildEmptyItem())
    }
  },
  watch: {
    items() {
      // @ts-ignore
      this.dataList = [this.buildEmptyItem()]
    },
    dataList: {
      handler(newVal: { [key: string]: string }[]) {
        // @ts-ignore
        this.update(newVal)
      },
      deep: true,
    }
  }
})
</script>
